
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery/[slug]",
      function () {
        return require("private-next-pages/gallery/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gallery/[slug]"])
      });
    }
  